
import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";

/**
 * 体检合同服务
 * @class
 * @version 1.0.0
 */
export default class ContractService extends ServiceBase
{

    /*
     * 体检合同服务实例
     * @private
     * @return ContractService
     */
    private static _instance: ContractService;

    /**
     * 体检合同服务实例
     * @static
     * @property
     * @returns ContractService
     */
    public static get instance(): ContractService
    {
        if(!this._instance)
        {
            this._instance = new ContractService();
        }
        
        return this._instance;
    }
    
    /**
     * 获取通知公告Banner列表
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getNoticeBannerList(): Promise<IHttpResponse>
    {

        let response = await this.apis.getNoticeBannerList({
        });

        return response;
    }
    
    /**
     * 获取通知公告跑马灯列表
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getNoticeMarqueeList(): Promise<IHttpResponse>
    {

        let response = await this.apis.getNoticeMarqueeList({
        });

        return response;
    }
    
    /**
     * 获取通知弹框跑马灯列表
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getNoticePopUpList(): Promise<IHttpResponse>
    {

        let response = await this.apis.getNoticePopUpList({
        });

        return response;
    }
    
    /**
     * 读取消息
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async noticeRead(data: any): Promise<IHttpResponse>
    {

        let response = await this.apis.noticeRead({ data });

        return response;
    }
    
    /**
     * 消息分页
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async noticePageList(data: any): Promise<IHttpResponse>
    {

        let response = await this.apis.noticePageList({ data });

        return response;
    }
    
    /**
     * 获取通知公告实体类
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getNotice(id: any): Promise<IHttpResponse>
    {

        let response = await this.apis.getNotice({ params: {id: id} });

        return response;
    }

    
}
